<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">RH</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row align-center>
                <v-flex xs3>
                  <v-chip label color="orange lighten-2" class="py-2 icon-chip">
                    <v-icon dark>fas fa-users</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs8>
                  <div class="headline">{{ indicateurRh('effectifs') }}  Collaborateurs</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 xl4>
          <v-card>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData" :options="chartOptions"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 xl4>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs3>
                  <v-chip label color="green lighten-1" class="py-2 icon-chip">
                    <v-icon dark>fas fa-plus</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs9>
                  <div class="headline">{{ serieRh('arrivees').length }}  Arrivées</div>
                </v-flex>
                <v-flex xs12>
                  <v-divider light></v-divider>
                  <v-list>
                    <template v-for="(item, index) in serieRh('arrivees')">
                      <v-list-tile :key="index">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 xl4>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs3>
                  <v-chip label color="red lighten-1" class="py-2 icon-chip">
                    <v-icon dark>fas fa-minus</v-icon>
                  </v-chip>
                </v-flex>
                <v-flex xs9>
                  <div class="headline">{{ serieRh('departs').length }}  Départs</div>
                </v-flex>
                <v-flex xs12>
                  <v-divider light></v-divider>
                  <v-list>
                    <template v-for="(item, index) in serieRh('departs')">
                      <v-list-tile :key="index">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item"></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import LineChart from '@/components/charts/LineChart.js'

export default {
  name: 'RessourcesHumaines',
  components: {
    LineChart
  },
  data(){
    return {
     
    }
  },
  computed: {
    ...mapGetters([
      'indicateurRh', 'serieRh'
    ]),
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Collaborateurs',
            backgroundColor: '#E53935',
            data: this.serieRh('effectifs')
          },
        ]
      }
    },
    chartOptions() {
      return {
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: this.indicateurRh('effectifs') - 20,
              suggestedMax: this.indicateurRh('effectifs') + 10
            }
          }]
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
